import { Controller } from "@hotwired/stimulus"

// Controller for handling changing the selected state of a row in a table
export default class extends Controller {
  static get targets() {
    return ["check"]
  }

  toggleCheck() {
    let checkedTargets = this.checkTargets.filter(checkboxTarget => { return checkboxTarget.checked })
    let eventPayload = {
      detail: {
        total: this.checkTargets.length,
        checked: checkedTargets.length,
        dataSets: checkedTargets.map(checkedTarget => checkedTarget.dataset)
      }
    }
    this.toggleSelectedCssClass(eventPayload)
    this.dispatch("selected", eventPayload)
  }

  toggleSelectedCssClass({ detail: { checked, dataSets }}) {
    let selectedDataSetIds = dataSets.map(dataSet => dataSet.messageId)
    let selectedTargets = this.checkTargets.filter(checkboxTarget => selectedDataSetIds.includes(checkboxTarget.dataset.messageId))
    let nonSelectedTargets = this.checkTargets.filter(checkboxTarget => !selectedDataSetIds.includes(checkboxTarget.dataset.messageId))
    selectedTargets.forEach((target) => {
      target.closest("tr").classList.add("selected")
    })
    nonSelectedTargets.forEach((target) => {
      target.closest("tr").classList.remove("selected")
    })
  }
}
